import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles((theme) => {
  return {
    mainSection: {
      height: "calc(100vh - 187px)",
      "&::-webkit-scrollbar": {
        width: "6px",
        borderRadius: "8px",
      },
      "&::-webkit-scrollbar-track": {
        backgroundColor: "#EDF5FB",
        borderRadius: "8px 8px 8px 0",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#465869",
        borderRadius: "8px",
      },
    },
    weightSection: {
      background: "#FFF",
      borderRadius: "8px",
      height: "42px",
      margin: "0px 6px 0px 6px",
      padding: "12px",
      marginTop: "12px",

      display: "flex",
      alignItems: "center",
      gap: "10px",
      justifyContent: "space-between",

      "& span": {
        fontFamily: "Manrope",
        fontStyle: "normal",
        fontWeight: "700",
        fontSize: "14px",
        lineHeight: "18px",
      },

      "& .span-info": {
        color: "#93A9BD",
      },

      "& .span-info-value": {
        color: "#465869",
      },

      "& .section-info": {
        display: "flex",
        alignItems: "center",
        gap: "16px",
        justifyContent: "flex-end",

        "& div": {
          display: "flex",
          gap: "3px",
        },
      },
    },
    shareSection: {
      background: "#FFF",
      borderRadius: "8px",
      height: "56px",
      margin: "0px 6px 0px 6px",
      padding: "12px",
      marginTop: "12px",

      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "10px",
    },
    headerIcon: {
      backgroundColor: "#308CDB4D",
      height: 40,
      width: 40,
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginRight: 16,
    },
    sharingTitle: {
      display: "flex",
      alignItems: "center",
      marginBottom: 16,
    },
    emptyInventory: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      width: "100%",
      flexDirection: "column",
      gap: "41px",

      "& > img": {
        width: "75%",
      },

      "& > span": {
        fontFamily: "Manrope",
        fontStyle: "normal",
        fontWeight: "700",
        fontSize: "16px",
        lineHeight: "150%",
        display: "flex",
        alignItems: "center",
        color: "#465869",
      },
    },

    modal: {
      maxWidth: "760px",
    },

    saveChangeContainer: {
      bottom: 0,
      width: "100%",
      zIndex: 3,
      position: "absolute",
    },
    saveChangeSection: {
      padding: "8px 10px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "flex-end",
      background: "#FFF",
      borderRadius: "12px",
      boxShadow: "0px 0px 6px rgba(152, 162, 179, 0.4)",
    },
    container: {
      position: "relative",
      height: "100%",
      width: "100%",
    },
    inventoryList: {
      height: "100%",
      width: "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      overflowY: "auto",
      "&::-webkit-scrollbar": {
        width: "6px",
        borderRadius: "8px",
      },
      "&::-webkit-scrollbar-track": {
        backgroundColor: "#EDF5FB",
        borderRadius: "8px 8px 8px 0",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#465869",
        borderRadius: "8px",
      },
    },
  };
});

export default styles;
